import { render, staticRenderFns } from "./TermsContent.vue?vue&type=template&id=bbf8766a&"
import script from "./TermsContent.vue?vue&type=script&lang=ts&"
export * from "./TermsContent.vue?vue&type=script&lang=ts&"
import style0 from "./TermsContent.vue?vue&type=style&index=0&id=bbf8766a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
